// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Canvas slide-over Node Catalog drawer — what is specific to this drawer.
 *
 * The panel itself (overlay root, scrim, sliding drawer, scroll body, section
 * label, card list, empty/error states, action-error banner) is the shared
 * ./CatalogDrawerShell.module.css, which the Data Catalog drawer also imports.
 * The two used to write all of that twice and had drifted apart in six places.
 *
 * Sub-component styles live in their own CSS modules:
 *   DrawerHeader.module.css     — top bar, subtitle, compat pill
 *   DrawerTabs.module.css       — tab strip
 *   PackageSearchRow.module.css — search input + sort select
 *   PackageCard.module.css      — package card + install buttons
 *   EnvNote.module.css          — environment info banner
 *   DrawerFooter.module.css     — footer actions
 */

/* This drawer's tier in the overlay scale (see curioTokens.css). Consumed by
   .overlayRoot in the shared shell. */
.d7ZQDcUaV6GurkdDYdQZ {
    --curio-drawer-z: var(--curio-z-node-drawer);
}

/* dev/92 B-2: informational (non-error) banner — the restart-honesty line. */
.hAddjozf9li3OBUsZuJD {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 12px;
    margin: 0 0 16px;
    background: rgba(80, 140, 255, 0.08);
    border: 1px solid var(--curio-border-strong, #7a9cc6);
    border-radius: var(--curio-radius-md);
    color: var(--curio-text-primary);
    font-size: var(--curio-font-size-md);
    font-family: var(--curio-font-family);
}

.iuaPzGtAjc8GvTfZOaps {
    flex-shrink: 0;
    background: transparent;
    border: none;
    color: inherit;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    padding: 0 4px;
    margin: -2px -2px 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/publishing/NodeCatalogDrawer.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;sCACsC;AACtC;IACI,4CAA4C;AAChD;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,qDAAqD;IACrD,qCAAqC;IACrC,gCAAgC;IAChC,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB","sourcesContent":["/*\n * Canvas slide-over Node Catalog drawer — what is specific to this drawer.\n *\n * The panel itself (overlay root, scrim, sliding drawer, scroll body, section\n * label, card list, empty/error states, action-error banner) is the shared\n * ./CatalogDrawerShell.module.css, which the Data Catalog drawer also imports.\n * The two used to write all of that twice and had drifted apart in six places.\n *\n * Sub-component styles live in their own CSS modules:\n *   DrawerHeader.module.css     — top bar, subtitle, compat pill\n *   DrawerTabs.module.css       — tab strip\n *   PackageSearchRow.module.css — search input + sort select\n *   PackageCard.module.css      — package card + install buttons\n *   EnvNote.module.css          — environment info banner\n *   DrawerFooter.module.css     — footer actions\n */\n\n/* This drawer's tier in the overlay scale (see curioTokens.css). Consumed by\n   .overlayRoot in the shared shell. */\n.overlayRoot {\n    --curio-drawer-z: var(--curio-z-node-drawer);\n}\n\n/* dev/92 B-2: informational (non-error) banner — the restart-honesty line. */\n.noticeBanner {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 10px 12px;\n    margin: 0 0 16px;\n    background: rgba(80, 140, 255, 0.08);\n    border: 1px solid var(--curio-border-strong, #7a9cc6);\n    border-radius: var(--curio-radius-md);\n    color: var(--curio-text-primary);\n    font-size: var(--curio-font-size-md);\n    font-family: var(--curio-font-family);\n}\n\n.noticeBannerDismiss {\n    flex-shrink: 0;\n    background: transparent;\n    border: none;\n    color: inherit;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    padding: 0 4px;\n    margin: -2px -2px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayRoot": `d7ZQDcUaV6GurkdDYdQZ`,
	"noticeBanner": `hAddjozf9li3OBUsZuJD`,
	"noticeBannerDismiss": `iuaPzGtAjc8GvTfZOaps`
};
export default ___CSS_LOADER_EXPORT___;
